<template>
  <div class="greybox">
    <h1>{{ repairOptionTitle }}</h1>
    <div v-if="showCardDetails">
      <h3 class="text-center">Total excess: &pound;{{ totalExcess }}</h3>
      <p>
        To proceed with your repair / replacement you will need to pay the
        applicable excess.
      </p>
      <claim-payment
        v-if="merchantAccountId && billingAddress"
        :merchantId="merchantAccountId"
        :billingAddressHidden="true"
        v-model="billingAddress"
        v-on:can-attempt-payment="onCanAttemptPayment"
        v-on:can-not-attempt-payment="onCanNotAttemptPayment"
        v-on:billing-address-change="onBillingAddressChange"
        :clearPaymentMethod="clearPaymentMethod"
      />
      <br /><br /><br />
      <transition name="fade">
        <div v-if="paymentResponseAdvice" class="text-danger mt-5 mb-5">
          <i class="fas fa-exclamation-triangle mr-2"></i
          ><strong>{{ paymentResponseAdvice }}</strong>
        </div>
      </transition>
      <button @click="handleCloseClick()" class="button mt-3 mr-2">Back</button>
      <button
        :disabled="!canAttemptPayment"
        class="button"
        @click="createTransactionWithAddress()"
      >
        Continue
      </button>
    </div>
    <div v-else-if="showBankDetails">
      <p>
        Please provide your bank details so that we can reimburse you minus any
        excess owed.
      </p>
      <bankDetails
        ref="bankDetails"
        v-model="bankObject"
        @isValid="handleBankDetailsIsValid"
      />
      <button @click="handleCloseClick()" class="button mt-3 mr-2">Back</button>
      <button class="button" @click="handleUpdateClaim()">Continue</button>
    </div>
    <div v-else>
      <p>To proceed with your repair / replacement click Continue.</p>

      <button @click="handleCloseClick()" class="button mt-3 mr-2">Back</button>
      <button class="button" @click="setRepairOption(selectedGadgetId)">
        Continue
      </button>
    </div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
  </div>
</template>
<script>
import loading from "vue-loading-overlay";
import { mapActions } from "vuex";
import cardDetails from "@/components/CardDetails.vue";
import ClaimPayment from "@/components/claim-payment.vue";
import bankDetails from "@/components/BankDetails.vue";
import { authHeader } from "@/util/authHeader";
import { repairOptionsService } from "@/services/repairOptions-api.service";
import repairOptionsBase from "@/mixins/repairOptionsBase";

import { braintreeService } from "@/services/braintree.service.js";
import { appSettingsService } from '@/services/appsettings.service.js'

export default {
  name: "RepairOptionsContinue",
  components: {
    cardDetails,
    bankDetails,
    ClaimPayment,
    loading,
  },
  mixins: [repairOptionsBase],
  data: () => {
    return {
      cardDetailsValid: false,
      setRepairOptionResponse: null,
      errors: [],

      bankObject: null,
      bankDetailsValid: null,

      settingsService: appSettingsService,
      merchantAccountId: null,
      billingAddress: null,
      canAttemptPayment: false,
      braintree: braintreeService,
      paymentNonce: null,

      optionService: repairOptionsService,
      clearPaymentMethod: false,
    };
  },
  async beforeMount() {
    try {
      await this.settingsService.getMerchantAccountId().then((response) => {
          try {
              //console.log('view getMerchantAccountId Success');
              this.merchantAccountId = response
          } catch (err) {
              throw err;
          }
      });

      //this.populateCardDetailsFromClaimant();
      await this.populateBillingAddressFromClaimant()
      this.paymentResponse = null;
    } catch (err) {
      console.log(err);
      this.$router.push({ path: "/myclaims/" });
    }
  },
  computed: {
    showCardDetails() {
      if (this.selectedRepairOption.repairOptionWebDisplayRequireCardDetails) {
        if (this.isStandalone == true) {
          if (!this.selectedGadget.excessCardPayment) {
            return true
          } else {
            if (this.selectedGadget.excessCardPayment.statusId != 1022) {
              return true
            } 
          }  
        } else {
          if (!this.selectedClaim.excessCardPayment) {
            return true
          } else {
            if (this.selectedClaim.excessCardPayment.statusId != 1022) {
              return true
            } 
          }
        } 
      }
      return false      
      // if (this.selectedRepairOption.repairOptionWebDisplayRequireCardDetails) {
      //   if (!this.selectedGadget.excessCardPayment) {
      //     return true;
      //   } else {
      //     if (this.selectedGadget.excessCardPayment.statusId != 1001 && this.selectedGadget.excessCardPayment.statusId != 1022) {
      //       return true;
      //     }
      //   }
      // }

      // return false;
    },
    showBankDetails() {
      if (
        this.selectedRepairOption.requireBankDetails &&
        this.isBankDetailsEmpty
      ) {
        return true;
      }

      return false;
    },
    isBankDetailsEmpty() {
      let { bankDetails } = this.$store.state.myclaims.selectedClaim;
      if (bankDetails) {
        return bankDetails.name == "" || bankDetails.name == null;
      }
      return true;
    },
  },
  methods: {
    async populateBillingAddressFromClaimant () {
      if (this.selectedClaim.claimant) {
        let { line1, line2, city, county, postcode } = this.selectedClaim.claimant.address
        this.billingAddress = {
          amount: this.totalExcess,
          line1,
          line2,
          city,
          county,
          postcode
        }
      }
    },
    handleCloseClick() {
      this.$router.go(-1);
    },
    handlepaymentDetailsIsValid(value) {
      this.cardDetailsValid = value;
    },
    runValidation() {
      if (this.$refs.cardDetails.checkForm()) {
        this.payExcessSetRepairOption(this.selectedGadgetId);
      }
    },

    async setOptionIfPaymentSuccessful(payload) {
      //console.log("Set Settlement option");
      //console.log("-r: ", payload);
    },
    async onCanAttemptPayment(payload) {
      //console.log('onCanAttemptPayment-payload: ', payload)
      this.clearPaymentMethod = false;
      this.canAttemptPayment = true;
      this.paymentNonce = payload;
      this.paymentResponse = null;
      if (this.bankDetailsValid) {
        await this.createTransactionWithAddress()
      }
    },
    async onCanNotAttemptPayment() {
      this.clearPaymentMethod = false;
      this.canAttemptPayment = false;
    },
    async createTransactionWithAddress() {
      this.isLoading = true
      this.canAttemptPayment = false;
      let { billingAddress } = this;
      let request = {
        claimWebReference: this.selectedClaim.id,
        gadgetWebReference: this.selectedGadgetId,
        nonce: this.paymentNonce,
        billingAddress,
      };
      return await this.braintree
        .createTransactionIncBillingAddress(request)
        .then((response) => {
          try {
            //console.log("response.data: ", response.data);

            this.paymentResponse = response.data;
            if (
              this.paymentResponse &&
              this.paymentResponse.paymentSuccess === true
            ) {

              let opt = {
                ...this.selectedRepairOption,
                gadgetWebRef: this.selectedGadgetId,
                claimWebRef: this.selectedClaim.id,
              };

              this.optionService
                .setRepairOptionForGadget(opt)
                .then((response) => {
                  this.setRepairOptionResponse = response.data;
                  if (this.setRepairOptionResponse.success === true) {
                    this.setInstructions(
                      this.setRepairOptionResponse.instructionsHTML
                    );
                    this.loadSelectedClaim(this.selectedGadgetId);
                    this.$router.push({
                      path: "/myclaims/repairoptions/instructions",
                    });
                  } else {
                    this.errors.push("Set repair option error");
                  }
                })
                .catch(() => {
                  this.errors.push("Fatal error");
                });
            } else {
              if (
                !this.paymentResponse ||
                this.paymentResponse.redirect == true
              )
                this.$router.push({
                  path: "/myclaims/view/" + this.selectedClaim.id,
                });
              else {
                this.clearPaymentMethod = true;
                if (
                  !this.paymentResponse.paymentAdvice &&
                  this.paymentResponse.paymentAdvice.length == 0
                )
                  this.paymentResponse.paymentAdvice =
                    "We are unable to process your payment.";
              }
              this.isLoading = false
            }
          } catch (err) {
            this.isLoading = false
            throw err;
          }
        });
        
    },
    async onBillingAddressChange(payload) {
      console.log(payload);
      this.billingAddress.line1 = payload.line1;
      this.billingAddress.line2 = payload.line2;
      this.billingAddress.city = payload.town;
      this.billingAddress.county = payload.county;
      this.billingAddress.postcode = payload.postcode;
    },

    handleBankDetailsIsValid(value) {
      this.bankDetailsValid = value;
    },
    handleUpdateClaim() {
      if (this.$refs.bankDetails.checkForm()) {
        let bankObj = {
          claimWebReference: this.claimWebRef,
          ...this.bankObject,
        };
        this.addBankDetailsSetRepairOption(bankObj);
      }
    },
  },
};
</script>
